import React, { Component } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import { agendas } from "../../data/agendas";
import Person from "../../img/person.jpg";
import MoreButton from "./MoreButton";
import ParticipantsAdd from "./ParticipantsAdd";

export default class MeetingParticipants extends Component {
	state = {
		participants: [
			{
				value: "Shaheen",
				email: "mail@example.com"
			}
		]
	};

	handleUser = users => {
		// console.log(users);
		this.setState({
			participants: [...this.state.participants, ...users]
		});
	};

	render() {
		return (
			<Grid container>
				<Grid item xs={12} md={8}>
					<ParticipantsAdd handleUser={this.handleUser} />
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<div>
								<List>
									{this.state.participants.map(participant => (
										<ListItem>
											<ListItemAvatar>
												<Avatar alt="person" src={Person} />
											</ListItemAvatar>
											<ListItemText primary={participant.value} />
											<ListItemSecondaryAction>
												<MoreButton />
											</ListItemSecondaryAction>
										</ListItem>
									))}
								</List>
							</div>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		);
	}
}
